<template src="./App.html"></template>
<script lang="ts">
import Vue from 'vue';
import MapUp from './components/mapup/MapUp.vue';
import axios from 'axios';
import { connectionName as wkoConnectionName, initializeWkoManager } from '@owc/connection-wko-manager';
import { initializeStore } from '@seamless/store';
import { initializeComponentRegistry } from '@owc/component-registry-connection';
import { addUrlChangeListener, getNamespaceData } from '@seamless/router';
import { initAssetServer } from './plugins/__webpack_public_path__.js';
import { initRouter } from './plugins/router.js';
import { initVi18n } from './plugins/vI18n.js';
import { AnalyzeIdentifier } from './plugins/analyzeIdentifier.js';
import ErrorType from './enums/error-types.js';
import { store } from './store.js';
import { calculateBaseUrl } from './plugins/apiUrlProvider.js';
import { B2X_ACTIVE_PROFILE_CONNECTION_NAME, B2XActiveUserConnection } from '@dh-io-mhb2b/active-profile';
import { AUTHENTICATION_CONNECTION, getJwe, isLoggedIn, isPending } from '@b2x/authentication-library'; // optional, if you want to get types

initRouter();
initVi18n();

export default Vue.extend({
  store: store,
  name: 'nmouc-app',
  components: {
    MapUp: MapUp,
  },
  data() {
    return {
      context: '',
    };
  },
  computed: {
    analyzeIdentifier: function () {
      return AnalyzeIdentifier.ID;
    },
  },
  created() {
    initAssetServer();
  },
  mounted() {
    this.detectOS();
    this.$store.commit('calculateSmallWindowWidth', window.innerWidth);
    window.addEventListener('resize', this.resizeHandler);
    this.initAxions();
    this.initSearchParams();
    this.initSeamlessParams();
    addUrlChangeListener(this.urlChanged, { namespace: 'mapupdate' });
  },
  methods: {
    detectOS() {
      this.$store.commit('setUserAgent', navigator.userAgent);
      if (navigator.userAgent.toUpperCase().indexOf('WIN') !== -1) {
        this.$store.commit('setOS', 'WIN');
      } else if (
        navigator.userAgent.toUpperCase().indexOf('MAC') !== -1 &&
        navigator.userAgent.toUpperCase().indexOf('LIKE MAC') === -1 &&
        navigator.maxTouchPoints === 0
      ) {
        this.$store.commit('setOS', 'MAC');
      } else {
        this.$store.commit('setOS', 'NONE');
      }
    },
    resizeHandler() {
      this.$store.commit('calculateSmallWindowWidth', window.innerWidth);
    },
    initAxions() {
      axios.defaults.withCredentials = true;
      axios.defaults.headers.common['analyzeidentifier'] = AnalyzeIdentifier.ID;
      axios.defaults.params = {};
      axios.defaults.params['sourceApp'] = 'ONEWEB';
    },
    initSearchParams() {
      const to = getNamespaceData('mapupdate');
      this.$store.commit('setSearchParams', to.searchParams);
      if (to.searchParams['language'] !== undefined && to.searchParams['country'] !== undefined) {
        this.setLocale(to.searchParams['language'], to.searchParams['country']);
      }
      if (to.searchParams['vin'] !== undefined) {
        this.$store.commit('setVin', to.searchParams['vin']);
      }
      if (to.searchParams['model'] !== undefined) {
        this.$store.commit('setModel', ' ' + to.searchParams['model']);
      }
      if (to.searchParams['context'] !== undefined) {
        let context = to.searchParams['context'];
        this.context = context;
        this.addParam('context', context);
      }
      if (to.searchParams['productmarketname'] !== undefined) {
        this.productMarketName = to.searchParams['productmarketname'];
      }
      if (to.searchParams['ntg'] !== undefined) {
        this.ntg = to.searchParams['ntg'];
      }
      if (to.searchParams['onewebntg'] !== undefined) {
        let ntg = to.searchParams['onewebntg'];
        this.addParam('ntg', ntg);
        this.$store.commit('setOneWebNtg', ntg);
      }
      if (to.searchParams['generalrequestform'] !== undefined) {
        this.$store.commit('setSupportLink', to.searchParams['generalrequestform']);
      }
      if (to.searchParams['os'] !== undefined) {
        this.$store.commit('setOS', to.searchParams['os']);
      }
      if (to.searchParams['novinerror'] !== undefined) {
        setTimeout(() => this.$store.commit('setError', ErrorType.NO_VIN), 1000);
      }
      if (to.searchParams['activatebrowserdownload'] !== undefined) {
        this.$store.commit('activateBrowserDownload');
      }
      if (to.searchParams['activatefeaturetoggle'] !== undefined) {
        this.$store.commit('activateBrowserDownload');
      }
      this.identifyMode(to);
    },
    initSeamlessParams() {
      //component params
      const yourComponentRegistry = initializeComponentRegistry();
      const elementById = document.getElementsByTagName('nmouc-mapup')[0];
      if (elementById) {
        const attribute = elementById.getAttribute('component-id');
        if (attribute) {
          yourComponentRegistry.subscribe(attribute, (ourparams) => {
            const params = ourparams;
            this.$store.commit('setComponentRegistry', params.payload);
            if (axios.defaults.params['context'] === undefined) {
              const context = params.payload.context;
              this.context = context;
              this.addParam('context', params.payload.context);
            }
            if (this.$store.state.supportLink === undefined) {
              this.$store.commit('setSupportLink', params.payload.generalrequestform);
            }
          });
        }
      }
      //wko
      initializeWkoManager();
      const store = initializeStore();
      console.log('context', this.context);
      store.addConnection(new B2XActiveUserConnection()).then(() => {
        store.subscribe(B2X_ACTIVE_PROFILE_CONNECTION_NAME, (wkob2b) => {
          console.log('wko_b2b', wkob2b);
          this.$store.commit('setWkoB2B', wkob2b);
            if (
              wkob2b.vehicles !== undefined &&
              wkob2b.vehicles[0] !== undefined &&
              wkob2b.vehicles[0].domainRef !== undefined
            ) {
              if (
                wkob2b.vehicles[0].domainRef.company != undefined &&
                wkob2b.vehicles[0].domainRef.company.meId != undefined
              ) {
                this.addParam('companyId', wkob2b.vehicles[0].domainRef.company.meId);
              }
              if (this.$store.vin === undefined) {
                if (wkob2b.vehicles[0].vin !== undefined) {
                  this.$store.commit('setVin', wkob2b.vehicles[0].vin);
                } else if (wkob2b.vehicles[0].fin !== undefined) {
                  this.$store.commit('setVin', wkob2b.vehicles[0].fin);
                } else if (wkob2b.vehicles[0].domainRef.vin !== undefined) {
                  this.$store.commit('setVin', wkob2b.vehicles[0].domainRef.vin);
                } else if (wkob2b.vehicles[0].domainRef.fin !== undefined) {
                  this.$store.commit('setVin', wkob2b.vehicles[0].domainRef.fin);
                }
              }
              if (wkob2b.vehicles[0].modelDescription !== undefined) {
                this.$store.commit('setModel', wkob2b.vehicles[0].modelDescription);
              }
            }
        });
      });
      if (process.env.VUE_APP_IS_LOCAL === 'true') {
        console.log('set  config to de - DE - INT', window);
        this.setLocale('de', 'DE');
        this.addBaseUrl(calculateBaseUrl('DE', 'LOCAL'));
      } else {
        if (window.aemNamespace === undefined || window.aemNamespace.pageEnvironmentVariables === undefined) {
          console.error('aemNamespace not defined');
          this.$store.commit('setError', ErrorType.NO_BASEURL);
        } else if (
          window.aemNamespace.pageEnvironmentVariables.stage === undefined ||
          window.aemNamespace.pageEnvironmentVariables.country === undefined ||
          window.aemNamespace.pageEnvironmentVariables.language === undefined
        ) {
          console.error('stage, country or language not defined', window.aemNamespace.pageEnvironmentVariables);
          this.$store.commit('setError', ErrorType.NO_BASEURL);
        } else {
          this.setLocale(
            window.aemNamespace.pageEnvironmentVariables.language,
            window.aemNamespace.pageEnvironmentVariables.country,
          );
          this.addBaseUrl(
            calculateBaseUrl(
              window.aemNamespace.pageEnvironmentVariables.country,
              window.aemNamespace.pageEnvironmentVariables.stage,
            ),
          );
        }
      }

      store.subscribe(wkoConnectionName, (wko) => {
        console.log('wko', wko);
        this.$store.commit('setWko', wko);
        const user = wko.User;

        if (this.context === 'B2C') {
          if (user.selectedAssociatedVehicle !== null && user.selectedAssociatedVehicle !== undefined) {
            if (this.$store.state.vin === undefined) {
              this.$store.commit('setVin', user.selectedAssociatedVehicle.finOrVin);
            }
          }
          if (user.associatedVehicles !== null && user.associatedVehicles !== undefined) {
            user.associatedVehicles.forEach((value) => {
              if (value.finOrVin === this.$store.state.vin) {
                if (this.$store.state.model === undefined) {
                  this.$store.commit('setModel', ' ' + value.modelDescription);
                }
                if (this.$store.state.oneWebNtg === undefined) {
                  let ntg = value.ntg;
                  this.addParam('ntg', ntg);
                  this.$store.commit('setOneWebNtg', ntg);
                }
              }
            });
          }
        }
      });

      store.subscribe(AUTHENTICATION_CONNECTION, (state) => {
        console.log('state', state);
        if (isLoggedIn(state) && !isPending(state)) {
          const jwe = getJwe(state);
          if (jwe !== undefined) {
            if (axios.defaults.headers.common['jwetoken'] !== jwe) {
              this.$store.commit('setJweAvailable', false);
              axios.defaults.headers.common['jwetoken'] = jwe;
              this.$store.commit('setJweAvailable', true);
            } else {
              console.log('same jwe');
            }
          }
        }
      });
      if (process.env.VUE_APP_TESTDATA === 'true') {
        this.$store.commit('setJweAvailable', true);
      }
    },
    addParam(key, value) {
      axios.defaults.params[key] = value;
    },
    addBaseUrl(baseUrl) {
      axios.defaults.baseURL = baseUrl;
      this.$store.commit('setBaseURL', baseUrl);
    },
    urlChanged(e) {
      this.identifyMode(e.to);
    },
    identifyMode(to) {
      if (to.subPathname === '/') {
        this.$store.commit('setMode', 'overview');
      } else if (to.subPathname === '/otachange') {
        this.$store.commit('setMode', 'otachange');
      } else if (to.subPathname === '/manualupdate') {
        this.$store.commit('setMode', 'manualupdate');
      } else if (to.subPathname === '/feedback') {
        this.$store.commit('setMode', 'feedback');
      }
    },
    setLocale(language, country) {
      if (this.$store.state.language !== undefined && this.$store.state.country !== undefined) {
        return;
      }
      this.addParam('locale', language + '_' + country);
      axios.defaults.headers.common['country'] = country;
      this.$i18n.locale = 'locale_' + language + '_' + country;
      this.$store.commit('setCountry', country);
      this.$store.commit('setLanguage', language);
    },
  },
});
</script>
<style lang="scss" src="./App.scss"></style>
